import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { ElectronicModel } from '@/types';
import { useGetElectronicModelsQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchElectronicModels<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  ...props
}: { config?: AxiosRequestConfig<ElectronicModel> } & Omit<
  AutocompleteProps<ElectronicModel, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const asyncGetElectronicModelsQueryProps = useAsyncSearch<ElectronicModel, Multiple, DisableClearable, FreeSolo>(
    useGetElectronicModelsQuery,
    'id',
    value,
    config,
  );

  return <Autocomplete {...props} {...asyncGetElectronicModelsQueryProps} />;
}

export default SearchElectronicModels;
